<script>
import YG10K from '../../../../../public/assets/front/images/findjewelry/10K-YG.webp'
import RG10K from '../../../../../public/assets/front/images/findjewelry/10K-RG.webp'
import WG10K from '../../../../../public/assets/front/images/findjewelry/10K.webp'

import YG14K from '../../../../../public/assets/front/images/findjewelry/14K-YG.webp'
import RG14K from '../../../../../public/assets/front/images/findjewelry/14K-RG.webp'
import WG14K from '../../../../../public/assets/front/images/findjewelry/14K.webp'

import YG18K from '../../../../../public/assets/front/images/findjewelry/18K-YG.webp'
import RG18K from '../../../../../public/assets/front/images/findjewelry/18K-RG.webp'
import WG18K from '../../../../../public/assets/front/images/findjewelry/18K.webp'

import G2T10K from '../../../../../public/assets/front/images/findjewelry/10K-2T.webp'
import G2T14K from '../../../../../public/assets/front/images/findjewelry/14K-2T.webp'
import G2T18K from '../../../../../public/assets/front/images/findjewelry/18K-2T.webp'

import Silver from '../../../../../public/assets/front/images/findjewelry/SS.webp'
import Platinum from '../../../../../public/assets/front/images/findjewelry/PT.webp'
import Palladium from '../../../../../public/assets/front/images/findjewelry/PD.webp'

const metals = [
	{ id:  105, src: WG10K, metalclass: "10kwhitegold", alt: "10K White Gold", disabled: true}, 
	{ id:  104, src: RG10K, metalclass: "10krosegold", alt: "10K Rose Gold", disabled: true}, 
	{ id:  103, src: YG10K, metalclass: "10kyellowgold", alt: "10K Yellow Gold", disabled: true},         
	{ id:  106, src: G2T10K, metalclass: "10k2tonegold", alt: "10K 2-Tone Gold", disabled: true},
	{ id:  141, src: Silver, metalclass: "silver", alt: "Silver", disabled: true}, 
	{ id:  102, src: WG14K, metalclass: "14kwhitegold", alt: "14K White Gold", disabled: true}, 
	{ id:  101, src: RG14K, metalclass: "14krosegold", alt: "14K Rose Gold", disabled: true}, 
	{ id:  100, src: YG14K, metalclass: "14Kyellowgold", alt: "14K Yellow Gold", disabled: true}, 
	{ id:  134, src: G2T14K, metalclass: "14k2tonegold", alt: "14K 2-Tone Gold", disabled: true}, 
	{ id:  140, src: Platinum, metalclass: "platinum", alt: "Platinum", disabled: true}, 
	{ id:  137, src: WG18K, metalclass: "18kwhitegold", alt: "18K White Gold", disabled: true}, 
	{ id:  136, src: RG18K, metalclass: "18krosegold", alt: "18K Rose Gold", disabled: true}, 
	{ id:  135, src: YG18K, metalclass: "18kyellowgold", alt: "18K Yellow Gold", disabled: true}, 
	{ id:  138, src: G2T18K, metalclass: "18k2tonegold", alt: "18K 2-Tone Gold", disabled: true}, 
	{ id:  139, src: Palladium, metalclass: "palladium", alt: "Palladium", disabled: true}           				
    ];

    export default metals
</script>